import { connect } from 'react-redux';
import compose from 'recompose/compose';
import * as actionCreators from '../actionCreators';
import OpenInMobile from '../components/OpenInMobile';
import onlyIf from '../hocs/onlyIf';
import { getOpenInMobileProps } from '../selectors/openInMobile';
function mapDispatchToProps(dispatch) {
    return {
        onClose: function () {
            dispatch(actionCreators.hideOpenInMobile());
        },
    };
}
export default compose(connect(getOpenInMobileProps, mapDispatchToProps), onlyIf(function (props) { return props.isVisible; }))(OpenInMobile);
